import React from "react";
import SeachForCompare from "../components/Forms/SeachForCompare";
import { MdSettingsApplications } from "react-icons/md";
import { AiFillCar } from "react-icons/ai";
import { GiDuck } from "react-icons/gi";
import { FaBookOpen } from "react-icons/fa";
import { GiClothes } from "react-icons/gi";
import { RiComputerLine } from "react-icons/ri";
import { BsCameraFill } from "react-icons/bs";
import { AiFillVideoCamera } from "react-icons/ai";
import { GiBrainFreeze } from "react-icons/gi";
import { GiGraveFlowers } from "react-icons/gi";
import { GiForkKnifeSpoon } from "react-icons/gi";
import { RiHealthBookLine } from "react-icons/ri";
import { GiGardeningShears } from "react-icons/gi";
import { GoHome } from "react-icons/go";
import { BsSmartwatch } from "react-icons/bs";
import { GiOfficeChair } from "react-icons/gi";
import { BsMusicNoteBeamed } from "react-icons/bs";
import ProductCard2 from "../components/Cards/ProductCard2";
import CompareTable from "../components/Container/CompareTable";
import Navbar from "./Navbar";
import Footer from "../components/layout/Footer";
import axios from "axios";

const Compare = () => {
  return (
    <div>
      <Navbar />
      <div className="bg-slate-100 py-4">
        <div className="w-full flex  justify-center  md:py-4">
          <div className=" w-full md:basis-5/12">
            <SeachForCompare />
          </div>
        </div>
        <div className="w-will flex justify-center">
          <div className="basis-7/12 flex justify-evenly mt-4 ">
            <ul>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <MdSettingsApplications className="inline mx-1" /> Appliance{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <AiFillCar className="inline mx-1" /> Auto parts
                </a>{" "}
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <GiDuck className="inline mx-1" /> Babies & kids
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <FaBookOpen className="inline mx-1" /> Books & Magazines
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <GiClothes className="inline mx-1" /> Clothing
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <RiComputerLine className="inline mx-1" /> Computes
                </a>
              </li>
            </ul>

            <ul>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700  "
                >
                  <BsCameraFill className="inline mx-1" /> Digital Camera{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <AiFillVideoCamera className="inline mx-1" /> DVD & Videos{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <GiBrainFreeze className="inline mx-1" /> Electronics
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <GiGraveFlowers className="inline mx-1" /> Gifts & Flowers
                </a>{" "}
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <GiForkKnifeSpoon className="inline mx-1" /> Foods
                </a>{" "}
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <RiComputerLine className="inline mx-1" /> Computes
                </a>
              </li>
            </ul>

            <ul>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <RiHealthBookLine className="inline mx-1" /> HEalth & Beauty{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <GiGardeningShears className="inline mx-1" /> Home & Garden{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <GoHome className="inline mx-1" /> Indoor Living
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <BsSmartwatch className="inline mx-1" /> Smart Watches{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <GiOfficeChair className="inline mx-1" /> Office Supplies{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700 "
                >
                  <BsMusicNoteBeamed className="inline mx-1" /> Music{" "}
                </a>
              </li>
            </ul>

            <ul>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <MdSettingsApplications className="inline mx-1" /> Appliance{" "}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <AiFillCar className="inline mx-1" /> Auto parts
                </a>{" "}
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <GiDuck className="inline mx-1" /> Babies & kids
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <FaBookOpen className="inline mx-1" /> Books & Magazines
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <GiClothes className="inline mx-1" /> Clothing
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-xs font-medium hover:text-blue-500 text-gray-700"
                >
                  <RiComputerLine className="inline mx-1" /> Computes
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="w-full px-12 py-12">
          <div className="w-full grid grid-cols-3 gap-3">
            <ProductCard2 />
            <ProductCard2 />
            <ProductCard2 />
          </div>
        </div>
        <div className="w-full p-4">
          <CompareTable />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Compare;
